import React from "react";
import { Button } from "@caesars-ui/core";
import { versionSelector } from "~/state/globalSlice";
import { useSelector } from "react-redux";

const LatestDownloadBar = () => {
  const version = useSelector(versionSelector);
  return (
    <div className="mb-6">
      <Button
        type="primary"
        onClick={(e) => window.open(`/dist/caesars-ui.${version}.zip`, "_self")}
      >
        Download Caesars UI Zip
      </Button>
      <Button
        type="secondary"
        className="ml-4"
        onClick={(e) => window.open("/download", "_self")}
      >
        Visit Download Page
      </Button>
    </div>
  );
};

export default LatestDownloadBar;
